module.exports = __webpack_public_path__ + "assets/img/thumb-Employment-Inovations-Landing-Page.81215b8c.jpg";